import { render, staticRenderFns } from "./lin-icon.vue?vue&type=template&id=ca7c981c&scoped=true&"
import script from "./lin-icon.vue?vue&type=script&lang=js&"
export * from "./lin-icon.vue?vue&type=script&lang=js&"
import style0 from "./lin-icon.vue?vue&type=style&index=0&id=ca7c981c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7c981c",
  null
  
)

export default component.exports